<template>
  <div class="c_box">
    <div class="mask" v-if="!isOpen"></div>
    <!-- <div v-if="!cJson">暂未设置题目</div> -->
    <div class="set_box" v-if="!cJson">请设置题目</div>
    <div v-else class="choice_box">
      <div class="title">
        <div style="display: flex;">
          <!-- <span @click.stop="updateTitle()" style="min-width:fit-content">{{
            `（${option[cJson.type].name}）`
          }}</span
          > -->
					<span @click.stop="updateTitle()" v-if="!updateList.title">{{
            cJson.title ? cJson.title : "请填写标题"
          }}</span>
          <input
            v-if="updateList.title"
            ref="titleRef"
            class="editInput"
            v-model="checkJson.title"
            @blur="save"
            @keyup.enter="save"
            placeholder="请填写标题"
          />
        </div>
        <span style="color: #efa030;" v-if="cJson.score"
          >（{{ "分值：" + cJson.score + "分" }}）</span
        >
      </div>
      <div class="choices">
        <div class="choice" v-for="(item, index) in cJson.array" :key="index">
          <div
            class="choice_c"
            v-if="cJson.type == 2"
            @click.stop="updateAnswer(index)"
          >
            <el-checkbox
              class="choiceInput"
              v-model="cJson.answer"
              disabled
              :label="index"
            ></el-checkbox
            ><span
              v-if="!updateList.answer || updateList.answerIndex != index"
              :class="{ right: cJson.answer.indexOf(index) != -1 }"
              @click.stop="updateLabel(index)"
              >{{ item.option ? item.option : "空选项" }}</span
            >
            <input
              v-if="updateList.answer && updateList.answerIndex == index"
              style="background: none;color: #000;"
              class="editInput answerInput"
              :ref="`answerRef${index}`"
              v-model="checkJson.array[index].option"
              @blur="save"
              @keyup.enter="save"
              placeholder="请输入选项标题"
            />
            <span
              @click.stop="deleteChoice(index)"
              class="deleteChoice"
              >×</span
            >
          </div>
          <div
            class="choice_c"
            v-if="cJson.type == 1"
            @click.stop="updateAnswer(index)"
          >
            <el-radio
              class="choiceInput"
              v-model="cJson.answer[0]"
              disabled
              :label="index"
            ></el-radio
            ><span
              v-if="!updateList.answer || updateList.answerIndex != index"
              :class="{ right: cJson.answer.indexOf(index) != -1 }"
              @click.stop="updateLabel(index)"
              >{{ item.option ? item.option : "空选项" }}</span
            >
            <input
              v-if="updateList.answer && updateList.answerIndex == index"
              style="background: none;color: #000;"
              :ref="`answerRef${index}`"
              class="editInput answerInput"
              v-model="checkJson.array[index].option"
              @blur="save"
              @keyup.enter="save"
              placeholder="请输入选项标题"
            />
            <span
              @click.stop="deleteChoice(index)"
              class="deleteChoice"
              >×</span
            >
          </div>
        </div>
      </div>

      <div class="choiceBottom">
				<el-button type="primary" size="mini" @click.stop="addChoice">添加选项</el-button>
			</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    cJson: {
      type: Object
    },
		cJson2:{
			type:Object
		},
    isOpen: {
      type: Boolean,
      default: false
    },
    index: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      option: {
        1: { name: "单选题" },
        2: { name: "多选题" }
      },
      checkJson: {},
      updateList: {
        title: false,
        answer: false,
        answerIndex: 0
      }
    };
  },
  watch: {
    checkJson: {
      handler(newVal) {
        this.$emit("setJson", newVal, this.index);
      },
      deep: true
    },
		isOpen(newValue) {
      if (newValue) {
        if (!this.cJson2 || Object.keys(this.cJson2).length == 0) {
          this.checkJson = {
            title: "标题",
            type: 1,
            answer: ""
          };
        } else {
          this.checkJson = this.depthCopy(this.cJson2);
        }
      }
    }
  },
  methods: {
    depthCopy(s) {
      return JSON.parse(JSON.stringify(s));
    },
    updateTitle() {
      this.updateList.title = true;
      this.$nextTick(() => {
        this.$refs["titleRef"].focus();
      });
    },
    updateLabel(index) {
      this.updateList.answerIndex = index;
      this.updateList.answer = true;
      this.$nextTick(() => {
        console.log(this.$refs[`answerRef${index}`]);
        this.$refs[`answerRef${index}`][0].focus();
      });
    },
    save() {
      for (let key in this.updateList) {
        if (typeof this.updateList[key] === "boolean") {
          this.updateList[key] = false;
        }
      }
    },
    updateAnswer(index) {
			return;
      if (this.cJson.type == 1) {
        if (this.checkJson.answer.indexOf(index) == -1) {
          this.checkJson.answer = [index];
        }
      } else if (this.cJson.type == 2) {
        if (!this.checkJson.answer) {
          this.checkJson.answer = [];
        }
        if (!this.checkJson.answer.includes(index)) {
          this.checkJson.answer.push(index);
        } else {
          this.checkJson.answer.splice(this.checkJson.answer.indexOf(index), 1);
        }
      }
    },
    deleteChoice(index) {
      this.checkJson.array.splice(index, 1);
      if (this.checkJson.answer.indexOf(index) != -1) {
        this.checkJson.answer.splice(this.checkJson.answer.indexOf(index), 1);
      }
    },
		addChoice(){
			this.checkJson.array.push({ option: "选项" + (this.checkJson.array.length + 1), img: "" })
		}
  },
  mounted() {
    // if (!this.cJson || Object.keys(this.cJson).length == 0) {
    //   this.checkJson = {
    //     title: "标题",
    //     type: 1,
    //     array: [
    //       { option: "选项1", img: "" },
    //       { option: "选项2", img: "" }
    //     ],
    //     answer: ""
    //   };
    // } else {
    //   this.checkJson = this.depthCopy(this.cJson2);
    // }
  }
};
</script>

<style scoped>
@import "../../global_styles.css";

.choice_box > .choices > .choice {
  word-break: break-all;
}
.choice_box > .choices > .choice + .choice {
  margin-top: 5px;
}
.choice_box > .choices > .choice > .choice_c {
  display: flex;
  padding: 10px 0 15px 10px;
  border: solid 1px #3681fc;
  background-color: rgba(224, 234, 251, 0.4);
  border-radius: 50px;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  position: relative;
  width: calc(100% - 50px);
}
.choice_box > .choices > .choice > .choice_c > span {
  /* padding-right: 50px; */
  /* margin-left: 10px; */
}
.choice_box > .choices > .choice > .choice_c > .el-checkbox {
  margin-top: 4px;
  margin-right: 10px;
}
.choice_box > .choices > .choice > .choice_c > .el-radio {
  margin-top: 4px;
  margin-right: 10px;
}
.choice_c >>> .el-checkbox__label {
  display: none;
}

.choice_c >>> .el-radio__label {
  display: none;
}

.choice_c .right {
  color: #efa030;
}
/* .choice_c .right::after {
  content: "（正确答案）";
} */

.choice:hover > .choice_c > .deleteChoice {
  display: flex;
}

.deleteChoice {
  max-width: 25px;
  max-height: 25px;
  min-width: 25px;
  min-height: 25px;
  position: absolute;
  right: -30px;
  transform: translateY(2px);
  border-radius: 5px;
  color: #646a73 !important;
  background-color: #fff;
  cursor: pointer;
  font-weight: bold;
  font-size: 16px;
  display: none;
  padding-right: 0 !important;
  align-items: center;
  justify-content: center;
  transition: 0.3s;
  box-sizing: border-box;
}

.deleteChoice:hover {
  background-color: #e8e9e9;
}

</style>



// WEBPACK FOOTER //
// src/components/pages/test/add/components/choice/choice.vue